import React from 'react';

export const CrownIcon = props =>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="80"
    height="80"
    viewBox="0 0 80 80"
    style={{
      fillRule: 'evenodd',
    }}
    {...props}
  >
    <path
      d="M619.07,810.985H560.931c-5.613,0-8.944-2.913-8.944-9.2V760.472c0-4.707,1.577-5.947,5.049-.367,2.943,4.733,6.972,11.356,11.141,18.25,6.179-7.158,13.244-15.31,19.587-22.549,1.064-1.212,3.629-.962,4.47,0,5.464,6.222,12.843,14.741,19.484,22.445,4.108-6.776,8.134-13.317,11.249-18.146,3.559-5.517,5.047-4.34,5.047.367v41.316C628.014,807.6,624.685,810.985,619.07,810.985Z"
      transform="translate(-550 -743)"
    />
  </svg>;



// WEBPACK FOOTER //
// ./app/components/icons/crown-icon.js